$(document).on('turbolinks:request-start', function () {
  $('#loading-indicator').removeClass('d-none');
});

$(document).on('turbolinks:load', function () {
  let buttonIds = ['#quickSearchSubmitButton', '#agrochemicalSearchSubmitButton', '#herbicideSearchSubmitButton', "#productSearchSubmitButton"];

  buttonIds.forEach(function (buttonId) {
    $(buttonId).on('click', function (event) {
      event.preventDefault();
      $('#loading-indicator').removeClass('d-none');

      setTimeout(function () {
        event.target.form.submit();
      }, 500);
    });
  });

  $('.dataTables_wrapper').each(function () {
    let table = $(this).DataTable();
    table.on('preDraw', function () {
      $('#loading-indicator').removeClass('d-none');
    });
    table.on('initComplete', function () {
      $('#loading-indicator').addClass('d-none');
    });
  });

  setTimeout(function () {
    $('#loading-indicator').addClass('d-none');
  }, 500);
});
